import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { feedbackApi } from './feedback.api';
import { CreateFeedbackDto, UpdateFeedbackDto, GetFeedbackDto } from '~/types/feedback';

export const FEEDBACK_KEYS = {
  GET_FEEDBACK: (params: GetFeedbackDto) => ['feedback', params],
  GET_FEEDBACK_ALL: (params: GetFeedbackDto) => ['feedback', 'all', params],
  GET_FEEDBACK_BY_ID: (id: string) => ['feedback', id],
};

export const useGetFeedback = (params: GetFeedbackDto) => {
  return useQuery({
    queryKey: FEEDBACK_KEYS.GET_FEEDBACK(params),
    queryFn: () => feedbackApi.getFeedback(params),
  });
};

export const useGetAllFeedbackCrossOrg = (params: GetFeedbackDto) => {
  return useQuery({
    queryKey: FEEDBACK_KEYS.GET_FEEDBACK_ALL(params),
    queryFn: () => feedbackApi.getAllFeedbackCrossOrg(params),
  });
};

export const useCreateFeedback = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: feedbackApi.createFeedback,
    onSuccess: () => {
      // Invalidate ALL feedback queries
      queryClient.invalidateQueries({ queryKey: ['feedback'] });
      // Also refetch the current query
      queryClient.refetchQueries({ queryKey: ['feedback'] });
    },
  });
};

export const useUpdateFeedback = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateFeedbackDto }) =>
      feedbackApi.updateFeedback(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['feedback'] });
      queryClient.refetchQueries({ queryKey: ['feedback'] });
    },
  });
};